module.exports = __webpack_public_path__ + "img/e34ebcf.jpg";